var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];
      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }
    return t;
  };
  return __assign.apply(this, arguments);
};
import React from "react";
import { SiteMetadataContext } from "../context/site-metadata-context";
import { useEnv } from "./use-env";
export var useSiteMetadata = function () {
  var env = useEnv();
  var defaultSiteMetadata = {
    title: env.SITE_TITLE || '',
    titleTemplate: "%s - ".concat(env.SITE_TITLE),
    openGraphTitleTemplate: env.SITE_OPEN_GRAPH_TITLE_TEMPLATE || "%s - ".concat(env.SITE_TITLE),
    description: env.SITE_DESCRIPTION || '',
    headline: env.SITE_HEADLINE || '',
    image: env.SITE_IMAGE || '',
    siteUrl: env.SITE_URL || '',
    video: env.SITE_VIDEO || '',
    type: env.SITE_TYPE || 'website',
    twitter: env.SITE_TWITTER || '',
    threads: env.SITE_THREADS || '',
    youtube: env.SITE_YOUTUBE || '',
    facebook: env.SITE_FACEBOOK || '',
    linkedin: env.SITE_LINKEDIN || '',
    flickr: env.SITE_FLICKR || '',
    tiktok: env.SITE_TIKTOK || '',
    instagram: env.SITE_INSTAGRAM || '',
    name: env.SITE_NAME || '',
    url: env.SITE_URL || '',
    recaptchaKey: env.SITE_RECAPTCHA_KEY || '',
    termsPagePath: env.TERMS_PATH || '',
    privacyPagePath: env.PRIVACY_PATH || '',
    ownerName: env.ORG_NAME || ''
  };
  var context = React.useContext(SiteMetadataContext);
  return __assign(__assign({}, defaultSiteMetadata), context);
};